
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicle",
      function () {
        return require("private-next-pages/vehicle/index.js");
      }
    ]);
  